import React from "react";
import { Helmet } from "react-helmet";
import PageHero from "@webcore/components/domain/content-site/sections/PageHero";
import { blogPosts } from "@/content/blog/posts";

const Blog: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Blog — DataFabrIQ</title>
        <meta
          name="description"
          content="Essays on trusted data, auditable AI, and running finance and GTM on one source of truth — from the DataFabrIQ team."
        />
        <link rel="canonical" href="https://datafabriq.co/blog" />
      </Helmet>

      <PageHero
        eyebrow="// blog"
        heading={
          <>
            The DataFabrIQ <span className="accent">blog.</span>
          </>
        }
        subheading={
          <>
            Essays on trusted data, auditable AI, and running your business on one source of
            truth.{blogPosts.length === 0 && <> First posts are on the way.</>}
          </>
        }
        primaryLabel="Book a Demo →"
        secondaryLabel="Explore the platform"
        secondaryHref="/#platform"
      />

      {blogPosts.length > 0 && (
        <section className="cs-section cs-blog">
          <div className="cs-blog-inner">
            {blogPosts.map((post) => (
              <a key={post.slug} className="cs-blog-card" href={`/blog/${post.slug}`}>
                <div className="cs-blog-card-date">{post.displayDate}</div>
                <div className="cs-blog-card-body">
                  <h2>{post.title}</h2>
                  <p>{post.excerpt}</p>
                  <span className="cs-blog-card-more">Read the post →</span>
                </div>
              </a>
            ))}
          </div>
        </section>
      )}
    </>
  );
};

export default Blog;
